import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      listData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10
    },
    mutations: {
      setListData (state, val) {
        Vue.set(state, 'listData', val)
      },
      setTotal(state, val) {
        Vue.set(state, 'total', val)
      },
      setPageIndex(state, val) {
        Vue.set(state, 'pageIndex', val)
      },
      setPageSize(state, val) {
        Vue.set(state, 'pageSize', val)
      }
    },
    actions: {
      loadDoc ({ commit }, { listData, total, pageIndex, pageSize }) {
        commit('setListData', listData)
        commit('setTotal', total)
        commit('setPageIndex', pageIndex)
        commit('pageSize', pageSize)
        commit('setPageSize', listData)
      }
    }
  })
}